import type { ReactElement } from "react";

export function EditingAndLineage(): ReactElement {
  return (
    <>
      <h2>Editing an output</h2>
      <p>
        Select a finished frame and choose <strong>Use as input</strong>. The image is attached to
        the composer, which puts it into edit mode, and your next prompt describes the change rather
        than the whole picture.
      </p>
      <p>
        You can also attach images from your machine. Either way, the number of images a model
        accepts is part of its description, and the composer will not let you exceed it.
      </p>

      <h2>From frame NN</h2>
      <p>
        When a frame is made by editing another one, Darkroom records which frame it came from and
        shows it as <em>from frame 02</em>. That is the lineage: you can walk back from any image to
        the frame it was derived from, without relying on filenames or memory.
      </p>
      <p>
        Branching is fine. Two different edits of the same frame both point back at it, and the
        board holds them in the order you made them.
      </p>

      <h2>Masks</h2>
      <p>
        Some models accept a mask, which marks the part of the image to change. Darkroom only offers
        a mask where the selected model supports one; on models that do not, the whole image is the
        subject of the edit.
      </p>

      <h2>Text alongside the image</h2>
      <p>
        A few models reply with text as well as an image — a note on what they did, or why they did
        something differently. Where that happens the text is shown with the frame.
      </p>
    </>
  );
}
